import { Component, NgModule,OnInit } from '@angular/core';
import { AuthService } from '../../services';
@Component({
  selector: 'app-footer',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit  {
  constructor(private authService: AuthService) { }
  ngOnInit() {
    let footer = document.getElementsByTagName('footer')[0];
    //body.classList.remove("dx-viewport");

    // let approot= document.getElementsByTagName('app-root')[0];
    // approot.classList.remove("screen-medium");
    // approot.classList.remove("screen-large");
  }
 
}

@NgModule({
  declarations: [ FooterComponent ],
  exports: [ FooterComponent ]
})
export class FooterModule { }
